import { ButtonProps, colors, Button, Tooltip, font } from 'plume-ui'
import React from 'react'
import { css } from '@emotion/react'
import { IcomoonIcon } from '../../atoms/IcomoonIcon'
import { keyframes } from '@emotion/react'

export const DownloadButton: React.FC<
  {
    isLoading?: boolean
    count: number | null
  } & ButtonProps
> = (props) => {
  const hoverBgColor = 'rgba(0, 0, 0, 0.04)'
  const loadingBgColor = 'rgba(0, 0, 0, 0.06)'

  const buttonRef = React.useRef<HTMLDivElement | null>(null)

  return (
    <>
      <div
        ref={buttonRef}
        data-for="download-button"
        css={css`
          margin-top: -10px;
        `}
      >
        <Tooltip
          label={
            props.count != null && props.count > 2000
              ? '先頭2000件のみダウンロードできます'
              : ''
          }
          className="downloadButton-tooltip"
        >
          <Button
            className={props.className}
            isLoading={props.isLoading}
            disabled={props.disabled}
            size="small"
            css={
              props.isLoading
                ? css`
                    background-color: transparent;
                    color: transparent !important;
                    position: relative;
                    border: none;
                    &:hover {
                      color: ${colors.textStrong};
                      background-color: ${hoverBgColor};
                    }
                    &::after {
                      animation: ${spinAround} 500ms infinite linear;
                      border: 2px solid ${colors.border};
                      border-radius: 50%;
                      border-right-color: transparent;
                      border-top-color: transparent;
                      content: '';
                      display: block;
                      height: 1em;
                      position: absolute;
                      width: 1em;
                      position: absolute;
                      left: calc(50% - (1em / 2));
                      top: calc(50% - (1em / 2));
                      position: absolute !important;
                    }
                  `
                : css`
                    width: 120px;
                    height: 32px;
                    padding: 7.5px 0 !important;
                    border: none;
                    color: ${colors.textStrong};
                    background-color: ${props.isLoading
                      ? loadingBgColor
                      : 'transparent'};
                    font-size: 14px !important;
                    font-weight: ${font.weight.normal};
                    &:hover {
                      color: ${colors.textStrong};
                      background-color: ${hoverBgColor};
                    }
                    & > i {
                      margin-right: 6px;
                      font-weight: ${font.weight.bold};
                    }
                  `
            }
            {...props}
          >
            <IcomoonIcon name="download" />
            ダウンロード
          </Button>
        </Tooltip>
      </div>
    </>
  )
}

const spinAround = keyframes`
  @keyframes spinAround
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
`
